import {
  takeLatest,
  takeLeading,
  put,
  select,
  all,
  call,
} from 'redux-saga/effects';
import axios from 'axios';
import moment from 'moment';
import {
  selectDof,
  selectFilteredFlightIds,
  selectFlightIds,
  selectFlightTimes,
  selectFilterTimeStart,
  selectFilterTimeEnd,
  selectDestination,
} from './valetData.selector';
import {
  getFlightIdsSuccess,
  getFlightIdsFailure,
  setFlightIdsLoading,
  // getFilteredFlightIds,
  setCustomerDataLoading,
  getFlightTimesSuccess,
  getFlightTimesStart,
  getFlightTimesFailure,
  filterFlightIdsStart,
  filterFlightIdsSuccess,
  filterFlightIdsFailure,
  getCustomerDataStart,
  getCustomerDataFailure,
  getCustomerDataSuccess,
  setCustomerCount,
} from './valetData.actions';

import { selectCurrentUser } from '../user/user.selector';
import FlightDataActionTypes from './valetData.types';

export function* getFlightIds() {
  try {
    const date = yield select(selectDof);
    const user = yield select(selectCurrentUser);
    yield put(setFlightIdsLoading(true));

    const response = yield call(axios, {
      url:
        process.env.REACT_APP_LOCAL_URL + '/automation/runflightidautomation',
      method: 'post',
      data: { date, userAuth: user },
    });

    if (response.data.flightIds) {
      yield put(getFlightIdsSuccess(response.data.flightIds));

      yield put(getFlightTimesStart());
    } else {
      alert('No flights for selected date.');
      yield put(getFlightIdsSuccess([]));
    }
  } catch (error) {
    yield put(getFlightIdsFailure(error));
  } finally {
    yield put(setFlightIdsLoading(false));
  }
}

export function* getCustomerData() {
  try {
    const filteredFlightIds = yield select(selectFilteredFlightIds);
    const user = yield select(selectCurrentUser);
    yield put(setCustomerDataLoading(true));
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/automation/getcustomerdata',
      method: 'post',
      data: {
        flightIds: filteredFlightIds,
        userAuth: user,
      },
    });
    yield put(getCustomerDataSuccess(response.data.customerData));
    yield put(setCustomerCount(response.data.customerCount));
    yield put(setCustomerDataLoading(false));
    if (response.data.customerData.length === 0) {
      alert('No customer for selected Flights');
    }
  } catch (error) {
    alert('Error occurred while getting customer data');
    yield put(getCustomerDataFailure(error));
  }
}

export function* getFlightTimes() {
  try {
    yield put(setFlightIdsLoading(true));
    const flightIds = yield select(selectFlightIds);
    const date = yield select(selectDof);
    const user = yield select(selectCurrentUser);

    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/automation/flightTimes',
      method: 'post',
      data: { date, flightIds: flightIds, userAuth: user },
    });

    if (response.data.flightTimes) {
      yield put(getFlightTimesSuccess(response.data.flightTimes));

      yield put(filterFlightIdsStart());
    }
  } catch (error) {
    yield put(getFlightTimesFailure(error));
  } finally {
    yield put(setFlightIdsLoading(false));
  }
}

export function* filterFlights() {
  try {
    yield put(setFlightIdsLoading(true));
    let data = yield select(selectFlightTimes);
    let start = yield select(selectFilterTimeStart);
    let end = yield select(selectFilterTimeEnd);
    let destination = yield select(selectDestination);
    // yield console.log(destination);
    let filteredData = [];
    if (data) {
      //Loop ends when key becomes falsey
      for (let key, i = 0; (key = Object.keys(data)[i]); i++) {
        if (key && data[key]) {
          let dep = data[key].schedDep;
          // schedDep is an ISO UTC datetime string; compare only time-of-day
          const depMinutes = moment.utc(dep).hours() * 60 + moment.utc(dep).minutes();
          const startMinutes = moment(start).hours() * 60 + moment(start).minutes();
          const endMinutes = moment(end).hours() * 60 + moment(end).minutes();
          if (depMinutes >= startMinutes && depMinutes <= endMinutes) {
            if (key.indexOf(destination) >= 0) {
              filteredData.push(key);
            }
          }
        }
      }

      yield put(filterFlightIdsSuccess(filteredData));

      yield put(getCustomerDataStart());
    }
  } catch (error) {
    yield put(filterFlightIdsFailure(error));
  } finally {
    yield put(setFlightIdsLoading(false));
  }
}

export function* onGetFlightIdsStart() {
  yield takeLeading(
    FlightDataActionTypes.GET_VALET_FLIGHT_IDS_START,
    getFlightIds
  );
}

export function* onGetFlightTimesStart() {
  yield takeLeading(
    FlightDataActionTypes.GET_VALET_FLIGHT_TIMES_START,
    getFlightTimes
  );
}

export function* onGetCustomerDataStart() {
  yield takeLatest(
    FlightDataActionTypes.GET_VALET_CUSTOMER_DATA_START,
    getCustomerData
  );
}

export function* onFilterValetFlightsStart() {
  yield takeLatest(
    FlightDataActionTypes.FILTER_VALET_FLIGHTS_START,
    filterFlights
  );
}

export function* valetDataSagas() {
  yield all([
    call(onGetCustomerDataStart),
    call(onGetFlightIdsStart),
    call(onGetFlightTimesStart),
    call(onFilterValetFlightsStart),
  ]);
}
